import { render, staticRenderFns } from "./WxContextualizedHelp.vue?vue&type=template&id=32ce3a20&scoped=true"
import script from "./WxContextualizedHelp.vue?vue&type=script&lang=js"
export * from "./WxContextualizedHelp.vue?vue&type=script&lang=js"
import style0 from "./WxContextualizedHelp.vue?vue&type=style&index=0&id=32ce3a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ce3a20",
  null
  
)

export default component.exports